import FlashCardIcon from './study-flashcard.svg';
import QuizitIcon from './study-quizit.svg';
import TutorMeIcon from './study-tutorme.svg';
import FlashCardOutlineIcon from './study-flashcard-outline.svg';
import QuizitOutlineIcon from './study-quizit-outline.svg';
import TutorMeOutlineIcon from './study-tutorme-outline.svg';
import RecentlyStudiedIcon from './study-recently-studied.svg';

export {
  FlashCardIcon,
  QuizitIcon,
  TutorMeIcon,
  FlashCardOutlineIcon,
  QuizitOutlineIcon,
  TutorMeOutlineIcon,
  RecentlyStudiedIcon,
};
